import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '@mvneco/eb-core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompactTariffOption3TypeDto, IOptionTypeDto, PropertyTypeDto,
   SubscriptionGetCompactTariffOptions3RequestDto, SubscriptionGetCompactTariffOptions3ResponseDto } from 'src/app/shared/api-types';
import { TariffDataModel, TariffOptionGroupModel, TariffOptionModel } from '../store/models/tariff-data.model';

@Injectable({
  providedIn: 'root'
})
export class ProductCatalogueService {

  public updateProductCatalogue$: Subject<void> = new Subject<void>();
  constructor(
    private httpClient: HttpClient,
  ) { }

  public getProductCatalogue(sim: string): Observable<TariffDataModel> {
    const req: SubscriptionGetCompactTariffOptions3RequestDto = {
      sim,
    };

    // console.log('In getProductCatalogue() req:', req);

    return this.httpClient.post<SubscriptionGetCompactTariffOptions3ResponseDto>('services/V10/aldi-talk-internet-service-service/subscriptionGetCompactTariffOptions3', req).pipe(
      map((res: SubscriptionGetCompactTariffOptions3ResponseDto) => this.mapCompactTariffOptions3(res))
    );
  }

  public updateProductCatalogue(req): Observable<TariffDataModel> {
    // console.log('In updateProductCatalogue() req:', req);

    return this.httpClient.post<SubscriptionGetCompactTariffOptions3ResponseDto>('services/V10/aldi-talk-internet-service-service/subscriptionGetCompactTariffOptions3', req).pipe(
      map((res: SubscriptionGetCompactTariffOptions3ResponseDto) => this.mapCompactTariffOptions3(res))
    );
  }

  private mapCompactTariffOptions3(res: SubscriptionGetCompactTariffOptions3ResponseDto): TariffDataModel {
    // console.log('In mapCompactTariffOptions3() res:', res);

    if (isNullOrUndefined(res.productBundle)) {
      throw new Error('subscriptionGetCompactTariffOptions3: productBundle missing in the response');
    }

    const tariffData: TariffDataModel = {
      tenantId: res.productBundle.tariff.tenantId,
      tariffCode: res.productBundle.tariff.code,
      name: res.productBundle.tariff.name,
      hasOptionSelected: false,
      tariffOptionGroups: {},
      promotionText: res.productBundle?.promotiontext,
      infoText: res.productBundle?.infotext
      // for testing
      // promotionText: !isNullOrUndefined(res.productBundle.promotiontext) ? res.productBundle.promotiontext :
      //  'DEMO <span style="color:red;">PROMOTION</span> TEXT, <a href="https://www.advenage.com/">LINK</a>',
      // infoText: !isNullOrUndefined(res.productBundle.infotext) ? res.productBundle.infotext : 'DEMO INFO TEXT'
    };

    if (isNullOrUndefined(res.compactTariffOptions) || isNullOrUndefined(res.compactTariffOptions.compactTariffOption)) {
      return tariffData;
    }

    res.compactTariffOptions.compactTariffOption
      .map((option: CompactTariffOption3TypeDto) => this.map_CompactTariffOption3TypeDto_Option(option)) // Mock alternative: map_CompactTariffOption3TypeDto_Option_Mock()
      .forEach((tariffOption: TariffOptionModel) => {
        if (isNullOrUndefined(tariffData.tariffOptionGroups[tariffOption.groupCode])) {
          const newTariffOptionGroup: TariffOptionGroupModel = {
            code: tariffOption.groupCode,
            name: tariffOption.groupName,
            type: tariffOption.groupType,
            hasOptionSelected: false,
            tariffOptions: {}
          };
          newTariffOptionGroup.tariffOptions[tariffOption.code] = tariffOption;
          tariffData.tariffOptionGroups[newTariffOptionGroup.code] = newTariffOptionGroup;
        } else {
          tariffData.tariffOptionGroups[tariffOption.groupCode].tariffOptions[tariffOption.code] = tariffOption;
        }
      });

    // console.log('In mapCompactTariffOptions3() returning tariffData', tariffData);
    return tariffData;
  }

  private map_CompactTariffOption3TypeDto_Option_Mock(compactTariffOption: CompactTariffOption3TypeDto): TariffOptionModel {
    // console.log('In map_CompactTariffOption3TypeDto_Option_Mock() compactTariffOption:', compactTariffOption);

    let groupName: string = null;
    let groupType: string = null;
    let marketingTitle: string = null;
    let marketingBulletPoint: string = null;
    let isVisible = false;

    let compactTariffOptionClone = JSON.parse(JSON.stringify(compactTariffOption)); // deep copy, writable

    compactTariffOptionClone?.properties?.property?.forEach((property: PropertyTypeDto) => {
      switch (property.name) {
        case 'DisplayGroup':
          const values: string[] = property.value.split(':');

          // Mock and actual version of the following if-statement need to coexist by commenting out mock version before commit

          // Mock response - variant 1 - add 'Carousel' prefix, simulate groupNames different than Kombo-Pakete
          if (values.length >= 2) {
            const marketingTitle = compactTariffOptionClone.properties.property.find(p => p.name === 'MARKETINGTITLE')?.value;
            let prefixedGroupName: string;
            if (marketingTitle) {
              if (marketingTitle.includes('Daten-Paket')) {
                groupName = 'Daten-Pakete';
                prefixedGroupName = 'Carousel:' + groupName;
              } else if (marketingTitle.includes('Musik-Paket')) {
                groupName = 'Musik-Pakete';
                prefixedGroupName = 'Carousel:' + groupName;
              } else if (marketingTitle.includes('ALDI TALK mini')) {
                groupName = 'ALDI TALK mini';
                prefixedGroupName = 'Carousel:' + groupName;
              } else if (marketingTitle.includes('Kombi-Paket')) {
                groupName = 'Kombi-Pakete';
                prefixedGroupName = 'Carousel:' + groupName;
              } else if (marketingTitle.includes('Tarif ')) {
                groupName = 'Basistarif';
                prefixedGroupName = 'Carousel:' + groupName;
              } else {
                groupName = values[0];
                prefixedGroupName = groupName;
              }
            } 
            groupType = values[1];

            // Write back the mock property value (i.e. prefix it with 'Carousel:')
            (compactTariffOptionClone.properties.property.find(p => p.name === 'DisplayGroup') as any).value = prefixedGroupName + ':' + groupType;
          }

          // Actual response
          // if (values.length >= 2) {
          //   groupName = values[0];
          //   groupType = values[1];
          // }

          // console.log('In map_CompactTariffOption3TypeDto_Option_Mock() DisplayGroup property.value processing 1 - groupName/groupType:', groupName, groupType);
          // console.log('In map_CompactTariffOption3TypeDto_Option_Mock() DisplayGroup property.value processing 2 - property:', property);
          break;
        case 'MARKETINGTITLE':
          marketingTitle = property.value;
          break;
        case 'MARKETINGBULLETPOINT':
          marketingBulletPoint = property.value;
          break;
        case 'PresentationContext':
          if (property.value === 'CRM#all') {
            isVisible = true;
          }
          break;
        default:
          break;
      }
    });

    // Warning: Property `selectedByDefault` introduced in Jira ticket EB-17286 is slated to become deprecated at some time in the future
    const selectedByDefault = !!(
      compactTariffOptionClone?.properties?.property?.some(prop => prop.name === 'selectedByDefault') &&
      compactTariffOptionClone?.properties?.property?.filter(prop => prop.name === 'selectedByDefault')[0]?.value === 'true'
    );

    // Criteria expanded to match cases when some tariff option is shown as initially selected in accordance to MDAT-1275 (#17759, when status="ACTIVE")
    const active = compactTariffOptionClone?.groupCode === 'G2DATA' && compactTariffOptionClone?.status === 'ACTIVE';

    // console.log('In map_CompactTariffOption3TypeDto_Option_Mock() DisplayGroup final compactTariffOptionClone:', compactTariffOptionClone);

    return {
      ...compactTariffOptionClone,

      groupName,
      groupType,
      marketingTitle,
      marketingBulletPoint,
      isVisible,
      isSelected: selectedByDefault || active,
      selectedByDefault
    };
  }

  private map_CompactTariffOption3TypeDto_Option(compactTariffOption: CompactTariffOption3TypeDto): TariffOptionModel {
    // console.log('In map_CompactTariffOption3TypeDto_Option() compactTariffOption:', compactTariffOption);

    let groupName: string = null;
    let groupType: string = null;
    let marketingTitle: string = null;
    let marketingBulletPoint: string = null;
    let isVisible = false;

    compactTariffOption?.properties?.property?.forEach((property: PropertyTypeDto) => {
      switch (property.name) {
        case 'DisplayGroup':
          const values: string[] = property.value.split(':');
          if (values.length >= 3) {
            groupName = values[1];
            groupType = values[2];
          }
          // console.log('In map_CompactTariffOption3TypeDto_Option() DisplayGroup property.value processing 1 - groupName/groupType:', groupName, groupType);
          // console.log('In map_CompactTariffOption3TypeDto_Option() DisplayGroup property.value processing 2 - property:', property);
          break;
        case 'MARKETINGTITLE':
          marketingTitle = property.value;
          break;
        case 'MARKETINGBULLETPOINT':
          marketingBulletPoint = property.value;
          break;
        case 'PresentationContext':
          if (property.value === 'CRM#all') {
            isVisible = true;
          }
          break;
        default:
          break;
      }
    });

    // Warning: Property `selectedByDefault` introduced in Jira ticket EB-17286 is slated to become deprecated at some time in the future
    const selectedByDefault = !!(
      compactTariffOption?.properties?.property?.some(prop => prop.name === 'selectedByDefault') &&
      compactTariffOption?.properties?.property?.filter(prop => prop.name === 'selectedByDefault')[0]?.value === 'true'
    );

    // Criteria expanded to match cases when some tariff option is shown as initially selected in accordance to MDAT-1275 (#17759, when status="ACTIVE")
    const active = compactTariffOption?.groupCode === 'G2DATA' && compactTariffOption?.status === 'ACTIVE';

    return {
      ...compactTariffOption,

      groupName,
      groupType,
      marketingTitle,
      marketingBulletPoint,
      isVisible,
      isSelected: selectedByDefault || active,
      selectedByDefault
    };
  }
}
